import ReactDOM from "react-dom/client"
import App from "@/App"
import "@/styles/global.css"
import "@/dictionaries/i18n"

ReactDOM.createRoot(document.getElementById("root")!).render(<App />)
